import React from "react";
import T from "prop-types";
import { Warning } from "MODULES/shared/components";
import { renderIf } from "MODULES/shared/decorators";
import { SATL } from "MODULES/parts/constants";

const Stars = () => {
  const stars = Array.from({ length: 5 }, (_, _i) => (
    <i className="fa fa-star" ariaHidden />
  ));

  return (
    <div
      className={`score-wrap text-light-purple`}
      style={{ display: "inline" }}
    >
      {stars}
    </div>
  );
};

const TierTypeExchangeSrpWarning = () => (
  <Warning>
    Recommend 15% Exchange SRP minimum for <Stars /> part.
  </Warning>
);

export default renderIf(
  ({ part, srp, exchangeSrp }) =>
    part &&
    part.tier_type === SATL &&
    srp &&
    !part.pass_fail &&
    (!exchangeSrp || Number(exchangeSrp) < Number(srp) * 0.15)
)(TierTypeExchangeSrpWarning);

TierTypeExchangeSrpWarning.propTypes = {
  part: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/shared/TierTypeExchangeSrpWarning.jsx